<template>
<img />  
</template>

<script>
export default {

}
</script>